import { FluidTableHeader } from '@lmig/fluid-core';
import { h } from '@stencil/core';

import { RenderValue } from '../../../common/fluid-component-rendering.components';
import { Utils } from '../../../utils/utils';
import { isAdditionalHeaderTable } from '../internal/fluid-table-grouping.utils';

export interface TableFooterProps {
  headers: FluidTableHeader[];
  includeRowActions?: boolean;
  allowTabIndexRows: boolean;
  dataItems: any[];
}
/**
 * Renders a default table footer.
 */
export const TableFooter = (props: TableFooterProps) => {
  const { headers, includeRowActions, allowTabIndexRows, dataItems } = props;

  const shouldRender = headers.some((h) => h.footerValue);

  return (
    shouldRender && (
      <tr
        class={'fluid-table-footer'}
        tabIndex={Utils.setTabIndex(allowTabIndexRows)}>
        {!isAdditionalHeaderTable(headers) &&
          headers.some((h) => h.grouped) && (
            <td class='table-data-cell action-cell' />
          )}
        {headers.map(
          (header) =>
            header.visible && (
              <td>
                {header.footerValue && (
                  <RenderValue
                    value={header.footerValue(dataItems)}
                    renderComponent={header.footerRenderComponent}
                  />
                )}
              </td>
            )
        )}
        {includeRowActions && <td class='table-data-cell action-cell' />}
      </tr>
    )
  );
};
